import List from "./List";
// import Create from "./Create";
import Show from "./Show";
// import Edit from "./Edit";

export const WaitlistsList = List;
export const WaitlistsShow = Show;
// export const TagEdit = Edit;
// export const TagCreate = Create;
